/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_CopiedInputs */

const zh_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制！`)
};

const en_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied!`)
};

const es_share_copied = /** @type {(inputs: Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Copiado!`)
};

/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Share_CopiedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const share_copied = /** @type {((inputs?: Share_CopiedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_CopiedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_copied(inputs)
	if (locale === "en") return en_share_copied(inputs)
	return es_share_copied(inputs)
});